import { render, staticRenderFns } from "./PreviewBrandTemplate.vue?vue&type=template&id=1cc9de04"
import script from "./PreviewBrandTemplate.vue?vue&type=script&lang=js"
export * from "./PreviewBrandTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports